import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CedEstaTicket, CedEstaTicketmto } from '../../redux/actions';
import CardContainer from "../../Components/CardsContainer/CardsContainer";
import PacmanLoader from 'react-spinners/PacmanLoader';

import styles from './GenerarTicket.module.css';
import { FaSearch, FaInbox } from 'react-icons/fa';

const SeguimientoTicket = () => {
    const dispatch = useDispatch();
    const usuario = useSelector((state) => state.usuario);
    const estadoticket = useSelector((state) => state.estadoticket);
    const estadoticketmto = useSelector((state) => state.seguimto);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [showCards, setShowCards] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [areaFilter, setAreaFilter] = useState('Todos');

    useEffect(() => {
        if (usuario.usuario && usuario.usuario.cedula) {
            const cedula = usuario.usuario.cedula;
            Promise.allSettled([
                dispatch(CedEstaTicket(cedula)),
                dispatch(CedEstaTicketmto(cedula))
            ]).then((results) => {
                const allFailed404 = results.every(res =>
                    res.status === 'rejected' && res.reason?.response?.status === 404
                );

                if (allFailed404) {
                    setError('Usuario no tiene tickets generados o por cerrar');
                } else {
                    const anyOtherError = results.find(res =>
                        res.status === 'rejected' && res.reason?.response?.status !== 404
                    );
                    if (!estadoticket.length && !estadoticketmto.length && anyOtherError) {
                        setError('Error al cargar los tickets');
                    }
                }

                setTimeout(() => {
                    setLoading(false);
                    setShowCards(true);
                }, 1000);
            });
        } else {
            setLoading(false);
            setError('Usuario no tiene tickets generados');
        }
    }, [dispatch, usuario]);

    const transformMtoData = (mtoData) => {
        if (!Array.isArray(mtoData)) return [];
        const result = [];

        mtoData.forEach(item => {
            const ticketId = item.ticket.id;
            const registros = item.registros || [];

            if (registros.length === 0) {
                result.push({
                    equipo: item.equipo,
                    tickets: [{
                        ticketId: `mto-${ticketId}-base`,
                        registros: [{
                            id: `mto-reg-base-${ticketId}`,
                            estadoDescripcion: item.ticket.estado,
                            TicketId: ticketId,
                            fecha: item.ticket.fecha,
                            observacion: item.ticket.observacion,
                            flag: 2 // Maintenance area flag
                        }]
                    }]
                });
                return;
            }

            const groupedByFlag = registros.reduce((acc, reg) => {
                const flagKey = reg.flag !== undefined && reg.flag !== null ? reg.flag : 'no-flag';
                if (!acc[flagKey]) acc[flagKey] = [];
                acc[flagKey].push({
                    ...reg,
                    estadoDescripcion: reg.estado,
                    TicketId: ticketId,
                    fecha: reg.fecha,
                    observacion: reg.observacion,
                    flag: reg.flag || 2 // Ensure flag is 2 if missing for Mto
                });
                return acc;
            }, {});

            Object.keys(groupedByFlag).forEach(flagKey => {
                result.push({
                    equipo: item.equipo,
                    tickets: [{
                        ticketId: `mto-${ticketId}-${flagKey}`,
                        registros: groupedByFlag[flagKey]
                    }]
                });
            });
        });

        return result;
    };

    const combinedTickets = [
        ...(Array.isArray(estadoticket) ? estadoticket.map(t => ({ ...t, area: "Gest. TI", isMto: false })) : []),
        ...transformMtoData(estadoticketmto).map(t => ({ ...t, area: "Área Mto", isMto: true }))
    ];

    const filteredTickets = combinedTickets.filter(group => {
        const matchesArea = areaFilter === 'Todos' || group.area === areaFilter;
        const matchesSearch = group.tickets.some(t =>
            t.registros.some(r => r.TicketId.toString().includes(searchTerm))
        );
        return matchesArea && matchesSearch;
    });

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h2 className={styles.title}><FaSearch style={{ marginRight: '15px' }} /> Seguimiento de Tickets</h2>
                <p className={styles.subtitle}>Consulta el estado actual de tus requerimientos de TI y Mantenimiento.</p>

                <div className={styles.filterContainer}>
                    <div className={styles.searchWrapper}>
                        <FaSearch className={styles.searchIcon} />
                        <input
                            type="text"
                            placeholder="Buscar por # de ticket..."
                            className={styles.searchInput}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <select
                        className={styles.areaSelect}
                        value={areaFilter}
                        onChange={(e) => setAreaFilter(e.target.value)}
                    >
                        <option value="Todos">Todas las Áreas</option>
                        <option value="Gest. TI">Gestión TI</option>
                        <option value="Área Mto">Mantenimiento</option>
                    </select>
                </div>
            </header>

            {loading ? (
                <div className={styles.spinnerContainer}>
                    <PacmanLoader color="#3b82f6" loading={true} size={40} />
                </div>
            ) : (
                (error || combinedTickets.length === 0) ? (
                    <div className={styles.emptyState}>
                        <FaInbox className={styles.emptyIcon} />
                        <h3 className={styles.emptyTitle}>Sin Tickets Activos</h3>
                        <p className={styles.emptySubtitle}>
                            {error || 'Actualmente no tienes tickets generados o con seguimiento pendiente.'}
                        </p>
                    </div>
                ) : filteredTickets.length === 0 ? (
                    <div className={styles.emptyState}>
                        <FaSearch className={styles.emptyIcon} />
                        <h3 className={styles.emptyTitle}>Sin coincidencias</h3>
                        <p className={styles.emptySubtitle}>No se encontraron tickets que coincidan con tu búsqueda o filtro.</p>
                    </div>
                ) : (
                    <div className={styles.seguimientoContent}>
                        {showCards && <CardContainer estadoticket={filteredTickets} />}
                    </div>
                )
            )}
        </div>
    );
};

export default SeguimientoTicket;
